// @ts-ignore
import { hasProp, assert } from "@utils/assertion";
// @ts-ignore
import { isArray } from "@utils/arrayUtils";
// @ts-ignore
import { parseJsonWithNumbersAsBigint, renderJsonWithNumbersAsBigint, type ParserResult } from "@utils/json";
// @ts-ignore
import { toBase64 } from "@utils/blobUtils";
// @ts-ignore
import { DateTime } from "luxon";
// @ts-ignore
import { type ReadonlyUint8Array } from "@utils/arrayUtils";
import type { ContentItemType } from "../schema";

export function serialize_ContentItemType_internal(value: ContentItemType): unknown {
  return ((value: "UNKNOWN" | "SUMMARY" | "CATEGORY" | "CHANNEL" | "ACTIONABLE" | "MYLIST" | "CUSTOMPAGE" | "MIAB" | "EXPERT_VIDEO" | "CUSTOMER_STORY" | "QUICKWIN" | "VERIFY"): unknown => {
    return value;
  })(value);
}
export function serialize_ContentItemType(obj: ContentItemType): string {
  return renderJsonWithNumbersAsBigint(serialize_ContentItemType_internal(obj));
}
export function deserialize_ContentItemType_internal(value: unknown): ParserResult<ContentItemType> {
  return ((value: unknown): ParserResult<"UNKNOWN" | "SUMMARY" | "CATEGORY" | "CHANNEL" | "ACTIONABLE" | "MYLIST" | "CUSTOMPAGE" | "MIAB" | "EXPERT_VIDEO" | "CUSTOMER_STORY" | "QUICKWIN" | "VERIFY"> => {
    if (typeof value !== "string") {
      return { success: false, reason: `[#/components/schemas/ContentItemType]: '${value}' expected to be of type string.` };
    }
    switch (value) {
      case "UNKNOWN":
        return { success: true, value: "UNKNOWN" };
      case "SUMMARY":
        return { success: true, value: "SUMMARY" };
      case "CATEGORY":
        return { success: true, value: "CATEGORY" };
      case "CHANNEL":
        return { success: true, value: "CHANNEL" };
      case "ACTIONABLE":
        return { success: true, value: "ACTIONABLE" };
      case "MYLIST":
        return { success: true, value: "MYLIST" };
      case "CUSTOMPAGE":
        return { success: true, value: "CUSTOMPAGE" };
      case "MIAB":
        return { success: true, value: "MIAB" };
      case "EXPERT_VIDEO":
        return { success: true, value: "EXPERT_VIDEO" };
      case "CUSTOMER_STORY":
        return { success: true, value: "CUSTOMER_STORY" };
      case "QUICKWIN":
        return { success: true, value: "QUICKWIN" };
      case "VERIFY":
        return { success: true, value: "VERIFY" };
      default:
        return {
          success: false,
          reason: `[#/components/schemas/ContentItemType]: '${value}' expected to be enum, one of 'UNKNOWN, SUMMARY, CATEGORY, CHANNEL, ACTIONABLE, MYLIST, CUSTOMPAGE, MIAB, EXPERT_VIDEO, CUSTOMER_STORY, QUICKWIN, VERIFY'.`,
        };
    }
  })(value);
}
export function deserialize_ContentItemType(str: string): ParserResult<ContentItemType> {
  return deserialize_ContentItemType_internal(parseJsonWithNumbersAsBigint(str));
}
